import ServiceHero from '@/components/sections/ServiceHero'

export default function AuthorityHero() {
  return (
    <ServiceHero
      serviceName="Authority"
      titleLines={['SEO & Content', 'That Dominates']}
      description="Technical foundations and content strategies that build long-term dominance. We help you own the keywords that drive revenue, not just traffic."
    />
  )
}
